import { getObjectSnapPoints } from './getObjectSnapPoints';
import editorConfig from '~config/editorConfig';

/**
 * Get all potential snap points for a given orientation
 * @param {fabric.Canvas} canvas - The fabric canvas
 * @param {string} orientation - 'horizontal' or 'vertical'
 * @param {fabric.Object} excludeObject - Object to exclude from snap points
 * @param {Object} config - Configuration options
 * @returns {Array} Array of snap points
 */
export const getCanvasSnapPoints = (
  canvas,
  orientation,
  excludeObject = null,
  config = {}
) => {
  const snapPoints = [];
  const cfg = { ...editorConfig.snapSettings, ...config };

  // Get objects to consider for snapping
  const objects = canvas.getObjects().filter((obj) => {
    return (
      obj !== excludeObject &&
      !obj.isGuideline &&
      obj.visible &&
      obj.opacity > 0 &&
      // Exclude internal MagicFrame components
      typeof obj._magicFrame === 'undefined' &&
      !obj.excludeFromExport // This catches internal MagicFrame images
    );
  });

  objects.forEach((obj) => {
    const points = getObjectSnapPoints(obj);

    if (orientation === 'horizontal') {
      if (cfg.enableEdgeSnapping) {
        snapPoints.push({
          position: points.top,
          type: 'top',
          object: obj,
        });
        snapPoints.push({
          position: points.bottom,
          type: 'bottom',
          object: obj,
        });
      }
      if (cfg.enableCenterSnapping) {
        snapPoints.push({
          position: points.centerY,
          type: 'centerY',
          object: obj,
        });
      }
    } else {
      // vertical
      if (cfg.enableEdgeSnapping) {
        snapPoints.push({
          position: points.left,
          type: 'left',
          object: obj,
        });
        snapPoints.push({
          position: points.right,
          type: 'right',
          object: obj,
        });
      }
      if (cfg.enableCenterSnapping) {
        snapPoints.push({
          position: points.centerX,
          type: 'centerX',
          object: obj,
        });
      }
    }
  });

  // Add guidelines as snap points if enabled
  if (cfg.enableGuidelineSnapping) {
    const guidelines = canvas
      .getObjects()
      .filter((obj) => obj.isGuideline && obj !== excludeObject);

    guidelines.forEach((guideline) => {
      if (
        (orientation === 'horizontal' &&
          guideline.orientation === 'horizontal') ||
        (orientation === 'vertical' && guideline.orientation === 'vertical')
      ) {
        const position =
          orientation === 'horizontal' ? guideline.top : guideline.left;
        snapPoints.push({
          position: position,
          type: 'guideline',
          object: guideline,
        });
      }
    });
  }

  return snapPoints;
};
